import React from 'react'

const HorizontalBarIcon = () => {
    return (
        <svg width="100%" height="100%" viewBox="0 0 20 20">
            <g id="layer1">
            <path 
                d="M 0 2 L 0 18 L 20 18 L 20 17 L 1 17 L 1 2 L 0 2 z M 2 5 L 2 6 L 16 6 L 16 7 L 2 7 L 2 8 L 17 8 L 17 5 L 2 5 z M 2 9 L 2 10 L 8 10 L 8 11 L 2 11 L 2 12 L 9 12 L 9 9 L 2 9 z M 2 13 L 2 14 L 12 14 L 12 15 L 2 15 L 2 16 L 13 16 L 13 13 L 2 13 z " 
                style={{ fill: "#222222", fillOpacity: 1, stroke: "none", strokeWidth: "0px" }}
            />
            </g>
        </svg>
    )
}

export default HorizontalBarIcon